import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
// Components
import PickupRateZonesDropdown from '../../dropdowns/PickupRateZonesDropdown';
// Store
import { getRateZones, setRateZones } from 'src/slices/rateZones';
// Fetch
import { getRateZones as getRateZonesFromBackend } from 'src/fetch/rateZones';
// Helpers
import { has } from 'lodash';

const RateZonesFilter = ({ filter, onFilterChange, fieldInfo }) => {
  const { value } = filter;
  const dispatch = useDispatch();
  const rateZones = useSelector(getRateZones);
  const [displayValue, setDisplayValue] = useState(value);

  const onChange = (event) => {
    const newFilter = {
      ...filter,
      value: event.target.value?.value,
      fieldInfo,
    };

    onFilterChange.call(undefined, {
      nextFilter: newFilter,
    });

    setDisplayValue(event.target.value);
  };

  useEffect(() => {
    setDisplayValue(value);
  }, [value]);

  useEffect(() => {
    if (!rateZones || rateZones.length === 0) {
      getRateZonesFromBackend().then((data) => dispatch(setRateZones({ rateZones: data })));
    }
  }, []);

  useEffect(() => {
    if (!has(filter, 'fieldInfo')) {
      onFilterChange.call(undefined, {
        nextFilter: {
          ...filter,
          fieldInfo,
        },
      });
    }
  }, []);

  return (
    <div style={{ minWidth: '200px', maxWidth: '559px', marginTop: '-24px' }}>
      {(filter.operator !== 'isnull' && filter.operator !== 'isnotnull')
              && <PickupRateZonesDropdown onChange={onChange} value={displayValue} clearButton={false} isMultiSelect={false} />}
    </div>
  );
};

export default RateZonesFilter;
